import { render, staticRenderFns } from "./ItemNotFound.vue?vue&type=template&id=07cc1544&scoped=true&"
import script from "./ItemNotFound.vue?vue&type=script&lang=js&"
export * from "./ItemNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc1544",
  null
  
)

export default component.exports